import { createAuthClient } from '@iplan/auth';
import { getEnv } from './env';

export const authClient = createAuthClient({
  authority: getEnv('VITE_AUTH_AUTHORITY') ?? '',
  clientId: getEnv('VITE_AUTH_CLIENT_ID') ?? 'iplan-web-dev',
  clientSecret: getEnv('VITE_AUTH_CLIENT_SECRET'),
  redirectUri: `${window.location.origin}/auth/callback`,
  postLogoutRedirectUri: `${window.location.origin}/auth/signout`,
  silentRedirectUri: `${window.location.origin}/auth/silent-renew`,
  scope: getEnv('VITE_AUTH_SCOPE') ?? 'openid profile email',
  responseType: 'code',
  automaticSilentRenew: true,
  monitorSession: false,
  userStore: 'localStorage',
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
});
